<template>
    <div>
        <div class="header">
            <div class="gap-row-1xs">
                <div class="qrw-heading-sm bold qrw-text-content-base-primary">
                    {{ $t('tips_settings.title') }}
                </div>
                <div class="qrw-paragraph-lg qrw-text-content-base-secondary">
                    {{ $t('tips_settings.subtitle') }}
                </div>
            </div>

            <!-- <BaseBetaToggle size="md" v-model="tipsEnabled" /> -->
            <BasePushButton variant="fill" size="md" bgColor="background-success-default"
                textColor="content-base-inverse-primary" @click="tipsEnabled = true" v-if="!tipsEnabled">
                {{ $t('tips_settings.turn_on') }}
            </BasePushButton>

            <BasePushButton variant="fill" size="md" bgColor="background-error-default"
                textColor="content-base-inverse-primary" @click="tipsEnabled = false" v-else>
                {{ $t('tips_settings.turn_off') }}
            </BasePushButton>
        </div>
        <div class="content" :class="{
                        disabled: !tipsEnabled
                    }">
            <TipsModePanel />
            <TipsMerchantPanel v-if="tipsMode === 'corporate'" />
            <TipsSystemsPanel v-if="tipsMode === 'corporate'" />
            <TipsTeamPanel v-if="tipsMode === 'personal'" />
        </div>
    </div>

</template>

<style scoped>
.content {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    padding: 24px;
    overflow-y: auto;
    padding-bottom: 48px;

    background: var(--qrw-background-base-tertiary);
}

.content.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    background: var(--qrw-background-base-primary);
    padding: 24px;

    align-items: center;
}
</style>

<script>
import TipsModePanel from '@/components/tips/TipsModePanel.vue';
import TipsMerchantPanel from '@/components/tips/TipsMerchantPanel.vue';
import TipsSystemsPanel from '@/components/tips/TipsSystemsPanel.vue';
import TipsTeamPanel from '@/components/tips/TipsTeamPanel.vue';

export default {
    components: {
        TipsModePanel,
        TipsMerchantPanel,
        TipsSystemsPanel,
        TipsTeamPanel
    },
    computed: {
        tipsEnabled: {
            get () {
                return this.$store.state.cafe.tips.enabled;
            },
            set (value) {
                this.$store.commit('setTipsEnabled', value);
                this.$store.dispatch('saveCafe');
            }
        },
        tipsMode () {
            return this.$store.state.cafe.tips.mode;
        }
    }
}
</script>